import {Component, computed, OnInit, Signal, untracked} from '@angular/core';
import {Button} from 'primeng/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Textarea} from 'primeng/textarea';
import {ManageTaBaseComponent} from '../manage-ta-base-component.directive';
import {TaCostBubbleComponent} from '../../ta-cost-bubble/ta-cost-bubble.component';
import {DatePipe} from '@angular/common';
import {TableModule} from 'primeng/table';
import {ApprovalContext, UserTravelItinerary} from '../../../../api';
import {DialogService} from 'primeng/dynamicdialog';
import {TaToastComponent} from '../../ta-toast/ta-toast.component';
import {
  ItineraryDifferenceComparisonComponent
} from '../itinerary-difference-comparison/itinerary-difference-comparison.component';
import {TaApprovalsTableComponent} from '../ta-approvals-table/ta-approvals-table.component';
import {resolveItineraryTravellerId} from '../../../../util/general.utils';
import {currentPendingApproval, TRAVEL_APPROVAL_CONTEXTS} from '../../../../util/approval-workflow.utils';
import {ManageTaDayTripPaymentTable} from '../manage-ta-day-trip-payment-table/manage-ta-day-trip-payment-table';

@Component({
  selector: 'manage-ta-acquittal-approval',
  imports: [
    Button,
    ReactiveFormsModule,
    Textarea,
    FormsModule,
    TaCostBubbleComponent,
    DatePipe,
    TableModule,
    TaToastComponent,
    ItineraryDifferenceComparisonComponent,
    TaApprovalsTableComponent,
    ManageTaDayTripPaymentTable,
  ],
  providers: [
    DialogService,
  ],
  templateUrl: './manage-ta-acquittal-approval.component.html',
  styleUrl: './manage-ta-acquittal-approval.component.scss'
})
export class ManageTaAcquittalApprovalComponent extends ManageTaBaseComponent implements OnInit {
  readonly currentItinerary: Signal<UserTravelItinerary | undefined> = this.store.currentItinerary;
  acquittalApprovalNotes = "";

  // The travel and acquittal stages are listed as separate tables.
  readonly travelContexts = TRAVEL_APPROVAL_CONTEXTS;
  readonly acquittalContexts: ApprovalContext[] = ['Acquittal', 'SecondaryAcquittal'];
  // The approval the TA waits on - named to a view only user, e.g. a funding approver waiting on the manager.
  currentApproval = computed(() => currentPendingApproval(this.taSubmission()?.approvals));

  acquittalApprovalRole = computed<'primaryApprover' | 'viewOnly'>(() => {
    if (this.permissionService.canApproveAcquittal(this.taSubmission())) {
      return 'primaryApprover';
    }
    return 'viewOnly';
  });
  showOverPaidWarning = computed<boolean>(() => {
    const isPrepaid = untracked(() => !!this.taSubmission()?.travellers?.at(0)?.authorisedAdjustmentDate);
    return isPrepaid && this.isOverpaid();
  });
  canProcessPrepayment = computed(() => this.permissionService.canProcessPrepayment());
  isPrepaymentProcessed = computed(() => {
    return (this.taSubmission()?.approvals?.filter((approval) => (approval.actionContext === "PrePayment" && approval.status === "Actioned" && approval.actionType !== "Cancelled")) ?? []).length > 0
  });

  override ngOnInit() {
    super.ngOnInit();
    // Falls back past the primary traveller so an all-casual delegate TA - which has none - still
    // resolves to a traveller whose itinerary can be fetched.
    const id = resolveItineraryTravellerId(this.taSubmission(), this.store.user()?.id);
    if (id) {
      this.taSubmissionDatasource.loadTravellerItinerary(id);
    }

    this.taSubmissionDatasource.getAllItineraries();
  }

  confirmApproveTaAcquittal(action: 'approve' | 'withhold'): void {
    this.confirmationServiceWrapper.approveAcquittalConfirm(action, this.acquittalApprovalNotes, this.taSubmission()).subscribe({
      next: () => {
        this.goBack();
      },
      error: err => {
        console.error(err);
      },
      complete: () => {
        // console.log('Approve completed.');
      }
    });
  }

  confirmProcessPrepayment(): void {
    this.confirmationServiceWrapper.processPrepaymentConfirm().subscribe({
      next: () => {},
      error: err => {
        console.error(err);
      },
    });
  }

}
